module.exports = __webpack_public_path__ + "img/Arqueamento de Ramos 1.4ee6fa17.webp";